import { LoadingSpinner } from "components/LoadingSpinner";
import useDocumentTitle from "hooks/useDocumentTitle";
import RuleHistory from "pages/PayerRules/components/RuleHistory";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetCaseRateRulesetByIdQuery } from "store/queries/pricing";

import { BilateralToggle } from "./components/BilateralToggle";
import { CaseRateConflictBanner } from "./components/CaseRateConflictBanner";
import { ContractLanguageField } from "./components/ContractLanguageField";
import { CptCodes } from "./components/CptCodes";
import { ExcludedCptCodes } from "./components/ExcludedCptCodes";
import { Header } from "./components/Header";
import { PerDiemToggle } from "./components/PerDiemToggle";
import { ProviderAndPayerEditSection } from "./components/ProviderAndPayerEditSection";
import { RuleName } from "./components/RuleName";
import { SubmitEditCaseRate } from "./components/SubmitEditCaseRate";

export function EditCaseRateRulesPage() {
  useDocumentTitle("Edit Case Rate Rules");
  const { id } = useParams();
  const { data: ruleset, isLoading } = useGetCaseRateRulesetByIdQuery(id);

  const methods = useForm({
    defaultValues: {
      isDefault: ruleset?.data.isDefault ?? false,
      provider: {
        name: ruleset?.data.provider?.name,
        value: ruleset?.data.provider?.id,
      },
      payerName: {
        name: ruleset?.data?.payer?.name,
        value: ruleset?.data?.payer?.id,
      },
      groupName: ruleset?.data.groupName,
      cptCodes: ruleset?.data.cptCodes,
      excludedCptCodes: ruleset?.data.excludedCptCodes,
      isPerDiem: ruleset?.data.isPerDiem ?? false,
      isBilateral: ruleset?.data.isBilateral ?? false,
      contractLanguage: ruleset?.data.contractLanguage ?? "",
    },
  });

  useEffect(() => {
    if (ruleset) {
      methods.reset({
        isDefault: ruleset?.data.isDefault ?? false,
        provider: {
          name: ruleset?.data.provider?.name,
          value: ruleset?.data.provider?.id,
        },
        payerName: {
          name: ruleset?.data?.payer?.name,
          value: ruleset?.data?.payer?.id,
        },
        groupName: ruleset?.data.groupName,
        cptCodes: ruleset?.data.cptCodes,
        excludedCptCodes: ruleset?.data.excludedCptCodes,
        isPerDiem: ruleset?.data.isPerDiem ?? false,
        isBilateral: ruleset?.data.isBilateral ?? false,
        contractLanguage: ruleset?.data.contractLanguage ?? "",
      });
    }
  }, [ruleset, methods]);

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <FormProvider {...methods}>
      <Header name={ruleset?.data.groupName} isCaseRate />
      <ProviderAndPayerEditSection />
      <RuleName />
      <div className="grid">
        <PerDiemToggle />
        <BilateralToggle />
      </div>
      <CptCodes />
      <ExcludedCptCodes />
      <ContractLanguageField
        ruleType="CASE_RATE"
        ruleId={id}
        attachments={ruleset?.data.attachments}
      />
      <CaseRateConflictBanner excludeRulesetId={id} />
      {id && ruleset && <SubmitEditCaseRate id={id} />}
      <RuleHistory histories={ruleset?.data.history} />
    </FormProvider>
  );
}
